"use client";

import { PasswordInput, TextInput } from "@carbon/react";
import { useActionState } from "react";
import { loginAction, type LoginState } from "@/app/login/actions";
import { FormShell } from "@/components/FormShell";
import { loginCopy } from "@/lib/ui/login-copy";

const initialState: LoginState = { error: null };

export function LoginForm() {
  const [state, formAction, pending] = useActionState(loginAction, initialState);

  return (
    <FormShell
      layout="dialog"
      className="w-full"
      action={formAction}
      error={state.error}
      errorTitle={loginCopy.errorTitle}
      submitLabel={loginCopy.submit}
      pending={pending}
      pendingLabel={loginCopy.pending}
    >
      <TextInput
        id="email"
        name="email"
        type="email"
        labelText="Email"
        autoComplete="username"
        required
      />
      <PasswordInput
        id="password"
        name="password"
        labelText="Пароль"
        autoComplete="current-password"
        required
      />
    </FormShell>
  );
}
